import { z } from "zod";
import { DemoIdentitySchema } from "../../demos/registry";

export const AdminLoginResponseSchema = DemoIdentitySchema.extend({
  token: z.string().min(1),
}).strict();

export type AdminLoginResponse = z.infer<typeof AdminLoginResponseSchema>;

export const AdminWebsiteCreateResponseSchema = z.object({
  websiteId: z.uuid(),
  // The new client and its default TOV version, so the caller can attach brand
  // guidelines (upload-your-own) to the version after creation.
  clientId: z.uuid(),
  tovVersionId: z.uuid(),
});

export type AdminWebsiteCreateResponse = z.infer<
  typeof AdminWebsiteCreateResponseSchema
>;
